import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useEffect, useState } from 'react';
import { useRouter } from '../../../router';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';


//import { useStoreAdmin } from '../../../../context/useStoreAdmin';

import { Button, ButtonDropdownProps, Link, Modal, SpaceBetween, Table, TextFilter } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiFileExcel } from '@mdi/js';
import Icon from '@mdi/react';
import { addMonths, format, max, parse } from 'date-fns';
import * as XLSX from "xlsx";
import BadgeUserType from '../../../../../components/extras/BadgeUserType';
import Favorites from '../../../../../components/extras/Favorites';
import TableMovements from '../../../../../components/tables/tableMovements';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { btnIconForm, ItemsMovement } from '../../../../../resources/types';
import { buildBreadcrumbItems, formatCurrency, getCookie, getUrlVersion, getUserType, setLoading } from '../../../../commons/functions';


type ItemReport = {
  idUser: number;
  idUserType: number;
  payment: number;
  charge: number;
  balance: number;
  displayName: string;
  lastCharge: string;
  lastPayment: string;

}
export const ReportsFinanceOutstandingPage = () => {
  const { data, menu } = useGlobalState();
  useGlobalState();
  const { navigate } = useRouter();

  const [outstandings, setOutstandings] = useState<ItemReport[]>([]);
  const [movements, setMovements] = useState<ItemsMovement[]>();
  const [filterValue, setFilterValue] = useState("");


  const filtered: any[] = outstandings.filter((item) => {
    const searchWords = filterValue.toLowerCase().split(/\s+/).filter(Boolean);
    const text = [item.displayName, getUserType(item.idUserType, data).userType, item.lastCharge, item.lastPayment].join(" ").toLowerCase().replace(/[^a-z0-9]/g, "");
    return searchWords.every((word) => text.includes(word.replace(/[^a-z0-9]/g, "")));
  });
  const handleRefresh = async () => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/reports/finance/outstanding',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({})
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();
      if (data && data.report)
        setOutstandings(data.report)

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };


  const handleMovements = async (report: ItemReport) => {
    try {
      setLoading(true);
      const lastPayment = parse(report.lastPayment, "dd-MM-yyyy", new Date()) ?? new Date(0)
      const lastCharge = parse(report.lastCharge, "dd-MM-yyyy", new Date()) ?? new Date(0)
      const latestDate = max([lastPayment, lastCharge]);
      const dateEnd = format(latestDate, 'dd-MM-yyyy');
      const dateStart = format(addMonths(latestDate, -3), 'dd-MM-yyyy');
      const body = {
        idUser: report.idUser,
        dateStart: dateStart,
        dateEnd: dateEnd,
        orderBy: "dateTransaction",
        order: "desc",
        orderBy2: "idMovement",
        order2: "desc",
      };
      console.log(body)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/movements/list',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify(body)
      });
      if (!response.ok) { throw new Error(`HTTP error: ${response.status}`); }

      const data = await response.json();
      if (data && data.movements)
        setMovements(data.movements)

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleItemClick = (event: CustomEvent<ButtonDropdownProps.ItemClickDetails>, item: ItemReport) => {
    const { id } = event.detail;
    let url = "";

    switch (id) {
      case "user":
        url = "#admin/users?tab=movements&idUser=" + item.idUser;
        break;
      case "movements":
        url = "/#admin/movements/user?endDate=" + item.lastCharge + "&startDate=" + format(addMonths(parse(item.lastPayment, 'dd-MM-yyyy', new Date()), -12), 'dd-MM-yyyy') + "&idUser=" + item.idUser;
        break;
      case "support":
        url = "https://aws.amazon.com/support";
        break;
      default:
        return;
    }

    // Open URL in a new tab
    window.open(url, "_blank", "noopener,noreferrer");
  };
  useEffect(() => {
    handleRefresh();
  }, []);


  const exportToExcel = () => {
    // Convert JSON to worksheet

    let mExcel: any[] = (filtered.map((movement: any) => ({
      idUser: movement.idUser,
      user: movement.displayName,
      idUserType: movement.idUserType,
      userType: movement.userType,
      charges: movement.charge,
      payments: movement.payment,
      balance: movement.balance,
      lastCharge: movement.lastCharge,
      lastPayment: movement.lastPayment,
    })));
    const ws = XLSX.utils.json_to_sheet(mExcel);

    // Create a workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Movements");

    // Generate XLSX file and download
    XLSX.writeFile(wb, "movements.xlsx");
  };
  return (
    <CustomAppLayout
      toolsHide={true}
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1" actions={<Favorites />}>Saldos deudores</Header>
          <Table header={"Morosidades a la fecha actual"}
            variant='embedded'
            filter={
              <SpaceBetween direction='horizontal' size='xs'>
                <TextFilter
                  filteringText={filterValue}
                  filteringPlaceholder="Buscar..."
                  onChange={({ detail }) => setFilterValue(detail.filteringText)}
                />

                <Button disabled={outstandings.length === 0} onClick={exportToExcel} style={{ root: btnIconForm }}><Icon path={mdiFileExcel} size={1} /></Button>
              </SpaceBetween>
            }
            stickyHeader={true}

            columnDefinitions={[
              { id: "user", header: "Usuario", cell: item => item?.displayName },
              { id: "userType", header: "Tipo", cell: item => <BadgeUserType size='medium' type='min' idUserType={item.idUserType} /> },
              {
                id: "balance", header: "Saldo", cell: item => <Link onClick={() => {
                  handleMovements(item)
                }}>{formatCurrency(item?.balance, 'CLP')}</Link>
              },
              { id: "lastPayment", header: "Últ. abono", cell: item => item?.lastPayment },
              { id: "lastCharge", header: "Últ. cargo", cell: item => item?.lastCharge },

            ]}
            items={filtered || []}
          />
          <Modal size="large" visible={!!movements} onDismiss={() => setMovements(undefined)} closeAriaLabel="Close modal"
            header={<Header variant="h2">Movimientos últimos 3 meses</Header>}
          >
            <TableMovements movements={movements || []} visible={true} showBalance={true}
              dateFilter="NONE" refresh={false} showUser={false}

            />

          </Modal>
        </SpaceBetween>
      }
    />
  );
};
